import * as React from 'react';

const SvgChevronDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#56565b"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="chevron-down_svg__feather chevron-down_svg__feather-chevron-down"
    {...props}
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export default SvgChevronDown;
